import { API_BASE_URL, SOCKETURL, PFR_API_URL } from "./site_urls";

export const APPLICATION_NAME = "RodeoPicks";
export const APPLICATION_GLOBAL_SLUG = "rodeo-pick";
export const APPLICATION_VERSION = "1.0.1";
export const STORAGE = "RODEO-APP";
export const SELECTED_EVENT_STORAGE = `${APPLICATION_NAME}-Event`;

export const INSIDERODEO_EVENT_STORAGE = `EXTERNAL-EVENT-FOR-RODEOPICK`;

export const RODEPICK_NEXT_GAME_IDS = `${APPLICATION_NAME}-NEXT-GAMES`;

export const IS_SHOWING_ADD_TO_HOME_SCREEN_IOS = `${APPLICATION_NAME}-IOS`;

export const PER_PAGE = 10;
export const WITHOUT_PER_PAGE = 99999;

export const FILE_BASE_PATH = "";
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_STAGE = process.env.REACT_APP_STAGE;

export const DATE_FORMAT = "MM/dd/yyyy";

export const DATE_ALL_FORMAT = {
  DATE_PICKER_FORMAT: "MM/dd/yyyy",
  MOMENT_FORMAT: "MM/DD/yyyy",
};

export const CHAT_DATE_TIME_FORMAT = {
  DISPLAY_DATE_WITH_TIME: "Do MMMM, YYYY hh:mm a",
  DISPLAY_DAY_TIME: "dddd hh:mm a",
};
export const TIME_CONFIG = {
  TIME_FORMAT: "hh:mm a",
  TIME_INTERVALS: 5,
};

export const SOCKET_URL = SOCKETURL;

export const URLS = {
  HOME: "/",
  GROUP_HOME: "/group/:groupId",
  LANDING: "/landing",
  // LEAGUE: "/league/:leagueId/:id",
  LOGIN: "/login",
  LOGIN_WITH_EMAIL: "/loginwithemail",
  REGISTRATION: "/registration",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_OTP: "/forgot-password-otp",
  RESET_PASSWORD: "/reset-password/:token",
  TV_IMAGE: "/tv-leaderboard/:gameId",
  GROUP_TV_IMAGE: "/group-tv-leaderboard/:groupId",
  USER: {
    AUTO_LOGIN: "/autologin/:token",
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",
  },
  CMS: {
    CMS: "/cms/:slug",
    // ABOUT_US: '/cms/about-us',
    // LEGAL: '/cms/legal',
    // HOW_TO_PLAY: '/cms/how-to-play',
    // TERM_OF_USE: '/cms/term-of-use',
  },
  EVENT: {
    LIST: "/events",
    PAST_RODEO_LIST: "/past-events",
    GROUPS: "/groups",
    EVENT_GAMES: "/event/:eventId/:performanceId",
    PERFORMANCES: "/performances/:eventId",
    EVENT_GAMES_DETAILS: "/event/:eventId/:gameId",
    RIDER_LIST: "/event/:eventId/:performanceId/:gameId",
    LEADER_BOARD: {
      EVENT: "/result/:eventId/:performanceId?",
      GAME: "/result/:eventId/:gameId",
      GROUP: "/group-result/:groupId",
    },
    PRIZES_LIST: "/prizes/:eventId/:performanceId",
    PRIZE: "/prize/:eventId/:performanceId/:type",
    WINNING_TICKET_RESULTS: "/winning-ticket/:eventId",
    MY_TEAM: "/my-team/:eventId",
    TEAM_IMAGE: "/team/:imageName",
    MOST_POPULAR_PICKS: "/most-popular-picks/:eventId/:performanceId",
    LEAGUE: "/league/:performanceId/:code",
    VS_LEAGUE: "/league/:code",
  },
};

export const API_URL = {
  USER: {
    LOGIN: `${API_BASE_URL}login`,
    LOGIN_WITH_OTP: `${API_BASE_URL}login-with-otp`,
    LOGIN_WITH_EMAIL: `${API_BASE_URL}login-with-email`,
    FORGOT_PASSWORD: `${API_BASE_URL}password/email`,
    RESET_PASSWORD: `${API_BASE_URL}reset-password`,
    REGISTRATION: `${API_BASE_URL}register`,
    LOGOUT: `${API_BASE_URL}auth/logout`,
    DETAILS: `${API_BASE_URL}init`,
    UPDATE_PROFILE: `${API_BASE_URL}users/update`,
    AUTO_LOGIN: `${API_BASE_URL}auto-login-with-token`,
    UPDATE_DISPLAY_NAME: `${API_BASE_URL}users/update-dispaly-name`,
    UPDATE_DOB: `${API_BASE_URL}users/update-dob`,
    CHECK_VALID_TOKEN: `${API_BASE_URL}check-valid-token`,
    SAVE_NOTIFICATION: `${API_BASE_URL}rodeo-pick/save-notification`,
    CREATE_UPDATE_USER_GAME: `${API_BASE_URL}create-update-user-game`,
    REGISTRATION_FIELDS: `${API_BASE_URL}registraton-fields`,
  },
  TV_IMAGE: {
    DETAILS: `${API_BASE_URL}rodeo-pick/leaderboard-tvimage`,
    GROUP_TV_IMAGE_DETAILS: `${API_BASE_URL}rodeo-pick/group-leaderboard-tvimage`,
  },
  EVENT: {
    GET_EVENT_LIST: `${API_BASE_URL}rodeo-pick/rodeo-event`,
    GET_PAST_EVENT_LIST: `${API_BASE_URL}rodeo-pick/past-rodeo-event`,
    EVENT_GROUPS: `${API_BASE_URL}rodeo-pick/rodeo-event-groups`,
    GET_EVENT_GAME: `${API_BASE_URL}rodeo-pick/rodeo-event/events`,
    PERFORMANCE_LIST: `${API_BASE_URL}rodeo-pick/rodeo-event/performances`,
    GET_EVENT_GAME_DETAILS: `${API_BASE_URL}rodeo-pick/rodeo-event/event-details`,
    PICK_RIDER: `${API_BASE_URL}rodeo-pick/rodeo-event/user-pick`,
    LEADERBOARD: `${API_BASE_URL}rodeo-pick/rodeo-event/leaderboard`,
    GROUP_LEADERBOARD: `${API_BASE_URL}rodeo-pick/rodeo-event/group-leaderboard`,
    SAVE_VOTE: `${API_BASE_URL}rodeo-pick/rodeo-event/save-vote`,
    GET_GAME_DETAILS: `${API_BASE_URL}get-game-list-details`,

    GET_UPCOMING_EVENT: `${API_BASE_URL}rodeo-race/upcoming-events`,
    JOIN_EVENT_GAME: `${API_BASE_URL}rodeo-race/rodeo-event/join`,

    PRIZE: `${API_BASE_URL}rodeo-pick/rodeo-event/prize`,
    GET_RODEO_EVENT_GEO_LOCATIONS: `${API_BASE_URL}get-rodeo-event-geo-locations`,
    LEADERBOARD_LOCATION_LIST: `${API_BASE_URL}rodeo-pick/rodeo-event/leader-board-location-list`,
    WINNING_TICKET_RESULTS: `${API_BASE_URL}rodeo-pick/rodeo-event/winning-ticket-results`,
    GET_MY_TEAM: `${API_BASE_URL}rodeo-pick/rodeo-event/my-teams`,
    MOST_POPULAR_PICKS: `${API_BASE_URL}rodeo-pick/rodeo-event/most-popular-picks`,
    SHARE_IMAGE_LINK: `${API_BASE_URL}rodeo-pick/rodeo-event/create-share-image-link`,
    YOUR_PICKS: `${API_BASE_URL}rodeo-pick/rodeo-event/your-picks`,
    GET_GAME_STATUS_TEXT: `${API_BASE_URL}get-game-status-text`,

    SAVE_LEAGUE_CODE: `${API_BASE_URL}rodeo-pick/rodeo-event/save-league-code`,
    LEAGUE_LEADERBOARD: `${API_BASE_URL}rodeo-pick/rodeo-event/league-leaderboard`,
    VS_LEAGUE_LEADERBOARD: `${API_BASE_URL}rodeo-pick/rodeo-event/vs-league-leaderboard`,
    SAVE_PIXEL_LOG: `${API_BASE_URL}rodeo-pick/save-pixel-log`,
  },
  CMS: {
    GET_CMS: `${API_BASE_URL}rodeo-race/get-cms`,
  },
  COMMON: {
    GENDER_LIST: `${API_BASE_URL}genders`,
    // COUNTRY_LIST: `${API_BASE_URL}country/list`,
    SECRET_QUESTION_LIST: `${API_BASE_URL}secret/questions`,
    COUNTRIES: `${PFR_API_URL}common/get-countries`,
    STATES: `${PFR_API_URL}common/get-states`,
    CITIES: `${PFR_API_URL}common/get-cities`,
    NEWSLETTER_SIGNUP: `${PFR_API_URL}newsletter/signup`,
  },
};

export const ACTIONS = {
  LOADER: {
    SET_FP_STATUS: "ACTIONS/LOADER/SET_FP_STATUS",
  },
  GLOBAL: {
    SET_LOGIN_MODAL: "ACTIONS/GLOBAL/SET_LOGIN_MODAL",
  },
  FORGOT_PASSWORD: {
    FORGOT_PASSWORD_STEP: "ACTIONS/FORGOT_PASSWORD/FORGOT_PASSWORD_STEP",
    FORGOT_PASSWORD_DATA: "ACTIONS/FORGOT_PASSWORD/FORGOT_PASSWORD_DATA",
  },
  USER: {
    LOGIN: "ACTIONS/USER/LOGIN",
    LOGIN_WITH_OTP: "ACTIONS/USER/LOGIN_WITH_OTP",
    ME: "ACTIONS/USER/ME",
    ONLINE_STATUS_CHANGE: "ACTIONS/USER/ONLINE_STATUS_CHANGE",
    SOCKET_INSTANCE_CONTAINER: "ACTIONS/USER/SOCKET_INSTANCE_CONTAINER",
    LOGOUT: "ACTIONS/USER/LOGOUT",
    PROFILE: "ACTIONS/USER/PROFILE",
    GUEST_USER_ID: "ACTIONS/USER/GUEST_USER_ID",
    RESET_GUEST_USER_ID: "ACTIONS/USER/RESET_GUEST_USER_ID",
    UPDATE_DISPLAY_NAME: "ACTIONS/USER/UPDATE_DISPLAY_NAME",
    UPDATE_DOB: "ACTIONS/USER/UPDATE_DOB",
  },
  EVENT: {
    GET_EVENT_LIST: "ACTIONS/EVENT/GET_EVENT_LIST",
    // GET_UPCOMING_EVENT: 'ACTIONS/EVENT/GET_UPCOMING_EVENT',
    GET_EVENT_GAME: "ACTIONS/EVENT/GET_EVENT_GAME",
    GET_EVENT_GAME_DETAILS: "ACTIONS/EVENT/GET_EVENT_GAME_DETAILS",
    GET_STATUS_MESSAGE: "ACTIONS/EVENT/GET_STATUS_MESSAGE",
    GET_IR_STATUS_MESSAGE: "ACTIONS/EVENT/GET_IR_STATUS_MESSAGE",
    LEADERBOARD: "ACTIONS/EVENT/LEADERBOARD",
    RODEO_EVENT_LOGIN_REQUIRED: "ACTIONS/EVENT/RODEO_EVENT_LOGIN_REQUIRED",

    OPEN_WINING_MODAL: "ACTIONS/EVENT/OPEN_WINING_MODAL",
    SET_PICK_ID: "ACTIONS/EVENT/SET_PICK_ID",
    RESET_PICK_ID: "ACTIONS/EVENT/RESET_PICK_ID",
    SITE_HEADER: "ACTIONS/EVENT/SITE_HEADER",

    GET_GAME_DETAILS: "ACTIONS/EVENT/GET_GAME_DETAILS",

    //SOCKET
    GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST: "ACTIONS/EVENT/GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST",
    GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS: "ACTIONS/EVENT/GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS",
    GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST:
      "ACTIONS/EVENT/GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST",
    GET_SOCKET_RIDER_WITH_VOTE_DETAILS: "ACTIONS/EVENT/GET_SOCKET_RIDER_WITH_VOTE_DETAILS",
    GET_WINING_SOCKET_DATA_AND_PUSH_TO_WINING_DETAILS: "ACTIONS/EVENT/GET_WINING_SOCKET_DATA",

    GET_EVENT_LIST_GLOWING_SOCKET: "ACTIONS/EVENT/GET_EVENT_LIST_GLOWING_SOCKET",
    RODEO_EVENT_SETTINGS: "ACTIONS/EVENT/RODEO_EVENT_SETTINGS",

    //Route change EVENT
    NEXT_EVENT_FROM_ROUTE: "ACTIONS/EVENT/NEXT_EVENT_FROM_ROUTE",
    SET_EVENT_IS_PICKED: "ACTIONS/EVENT/SET_EVENT_IS_PICKED",
  },
  TV_IMAGE: {
    DETAILS: "ACTIONS/TV_IMAGE/DETAILS",
  },
};

export const SAGA_ACTIONS = {
  USER: {
    LOGIN: "SAGA_ACTIONS/USER/LOGIN",
    LOGIN_WITH_OTP: "SAGA_ACTIONS/USER/LOGIN_WITH_OTP",
    LOGIN_WITH_EMAIL: "SAGA_ACTIONS/USER/LOGIN_WITH_EMAIL",
    REGISTRATION: "SAGA_ACTIONS/USER/REGISTRATION",
    FORGOT_PASSWORD: "SAGA_ACTIONS/USER/FORGOT_PASSWORD",
    RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
    LOGOUT: "SAGA_ACTIONS/USER/LOGOUT",
    DETAILS: "SAGA_ACTIONS/USER/DETAILS",
    UPDATE_PROFILE: "SAGA_ACTIONS/USER/UPDATE_PROFILE",
    AUTO_LOGIN: "SAGA_ACTIONS/USER/AUTO_LOGIN",
    UPDATE_DISPLAY_NAME: "SAGA_ACTIONS/USER/UPDATE_DISPLAY_NAME",
    UPDATE_DOB: "SAGA_ACTIONS/USER/UPDATE_DOB",
    CHECK_VALID_TOKEN: "SAGA_ACTIONS/USER/CHECK_VALID_TOKEN",
    SAVE_NOTIFICATION: "SAGA_ACTIONS/USER/SAVE_NOTIFICATION",
    CREATE_UPDATE_USER_GAME: "SAGA_ACTIONS/USER/CREATE_UPDATE_USER_GAME",
    REGISTRATION_FIELDS: "SAGA_ACTIONS/USER/REGISTRATION_FIELDS",
  },
  EVENT: {
    GET_EVENT_LIST: "SAGA_ACTIONS/EVENT/GET_EVENT_LIST",
    GET_PAST_EVENT_LIST: "SAGA_ACTIONS/EVENT/GET_PAST_EVENT_LIST",
    EVENT_GROUPS: "SAGA_ACTIONS/EVENT/EVENT_GROUPS",
    GET_EVENT_GAME: "SAGA_ACTIONS/EVENT/GET_EVENT_GAME",
    PERFORMANCE_LIST: "SAGA_ACTIONS/EVENT/PERFORMANCE_LIST",
    GET_EVENT_GAME_DETAILS: "SAGA_ACTIONS/EVENT/GET_EVENT_GAME_DETAILS",
    PICK_RIDER: "SAGA_ACTIONS/EVENT/PICK_RIDER",
    LEADERBOARD: "SAGA_ACTIONS/EVENT/LEADERBOARD",
    GROUP_LEADERBOARD: "SAGA_ACTIONS/EVENT/GROUP_LEADERBOARD",
    SAVE_VOTE: "SAGA_ACTIONS/EVENT/SAVE_VOTE",

    GET_UPCOMING_EVENT: "SAGA_ACTIONS/EVENT/GET_UPCOMING_EVENT",
    JOIN_EVENT_GAME: "SAGA_ACTIONS/EVENT/JOIN_EVENT_GAME",
    GET_GAME_DETAILS: "SAGA_ACTIONS/EVENT/GET_GAME_DETAILS",
    PRIZE_DETAILS: "SAGA_ACTIONS/EVENT/PRIZE_DETAILS",
    GET_RODEO_EVENT_GEO_LOCATIONS: "SAGA_ACTIONS/EVENT/GET_RODEO_EVENT_GEO_LOCATIONS",
    LEADERBOARD_LOCATION_LIST: "SAGA_ACTIONS/EVENT/LEADERBOARD_LOCATION_LIST",
    WINNING_TICKET_RESULTS: "SAGA_ACTIONS/EVENT/WINNING_TICKET_RESULTS",
    GET_MY_TEAM: "SAGA_ACTIONS/EVENT/GET_MY_TEAM",
    MOST_POPULAR_PICKS: "SAGA_ACTIONS/EVENT/MOST_POPULAR_PICKS",
    GET_SHARE_IMAGE_LINK: "SAGA_ACTIONS/EVENT/GET_SHARE_IMAGE_LINK",
    YOUR_PICKS: "SAGA_ACTIONS/EVENT/YOUR_PICKS",
    GET_GAME_STATUS_TEXT: "SAGA_ACTIONS/EVENT/GET_GAME_STATUS_TEXT",
    SAVE_LEAGUE_CODE: "SAGA_ACTIONS/EVENT/SAVE_LEAGUE_CODE",
    LEAGUE_LEADERBOARD: "SAGA_ACTIONS/EVENT/LEAGUE_LEADERBOARD",
    VS_LEAGUE_LEADERBOARD: "SAGA_ACTIONS/EVENT/VS_LEAGUE_LEADERBOARD",
    SAVE_PIXEL_LOG: "SAGA_ACTIONS/EVENT/SAVE_PIXEL_LOG",
  },
  TV_IMAGE: {
    DETAILS: "SAGA_ACTIONS/TV_IMAGE/DETAILS",
    GROUP_TV_DETAILS: "SAGA_ACTIONS/TV_IMAGE/GROUP_TV_DETAILS",
  },
  CMS: {
    GET_CMS: "SAGA_ACTIONS/COMMON/GET_CMS",
  },
  COMMON: {
    GENDER_LIST: "SAGA_ACTIONS/COMMON/GENDER_LIST",
    // COUNTRY_LIST: "SAGA_ACTIONS/COMMON/COUNTRY_LIST",
    SECRET_QUESTION_LIST: "SAGA_ACTIONS/COMMON/SECRET_QUESTION_LIST",
    COUNTRIES: "SAGA_ACTIONS/COMMON/COUNTRIES",
    STATES: "SAGA_ACTIONS/COMMON/STATES",
    CITIES: "SAGA_ACTIONS/COMMON/CITIES",
    NEWSLETTER_SIGNUP: "SAGA_ACTIONS/COMMON/NEWSLETTER_SIGNUP",
  },
};

export * from "./site_statics";
export * from "./site_urls";
export * from "./functions";
export * from "./canvasUtils";
export * from "./card_utils";
